webpackJsonp([97015758889679],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', ';\n  background-color: ', ';\n  background-image: linear-gradient(\n    -48deg,\n    ', ' 0%,\n    ', ' 50%,\n    ', ' 100%\n  );\n  padding: 4rem 0 !important;\n  ', ' {\n    padding-top: 5rem 0 !important;\n    ', ';\n  }\n  h3 {\n    font-weight: normal;\n    line-height: 1.5;\n    opacity: 0.9;\n  }\n'], ['\n  ', ';\n  background-color: ', ';\n  background-image: linear-gradient(\n    -48deg,\n    ', ' 0%,\n    ', ' 50%,\n    ', ' 100%\n  );\n  padding: 4rem 0 !important;\n  ', ' {\n    padding-top: 5rem 0 !important;\n    ', ';\n  }\n  h3 {\n    font-weight: normal;\n    line-height: 1.5;\n    opacity: 0.9;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(3);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var tilt = function tilt(n) {
	  return 'clip-path: polygon(0% ' + (100 - n) + '%, 100% 0, 100% ' + n + '%, 0 100%)';
	};
	
	var Base = _designSystem.Section.extend(_templateObject, tilt(90), function (props) {
	  return props.theme.colors.red[5];
	}, function (props) {
	  return props.theme.colors.orange[4];
	}, function (props) {
	  return props.theme.colors.red[5];
	}, function (props) {
	  return props.theme.colors.red[6];
	}, function (props) {
	  return props.theme.mediaQueries.lg;
	}, tilt(85));
	
	_designSystem.LargeButton.link = _designSystem.LargeButton.withComponent(_gatsbyLink2.default);
	
	var Start = function Start(_ref) {
	  var _ref$mt = _ref.mt,
	      mt = _ref$mt === undefined ? '-4rem' : _ref$mt,
	      props = _objectWithoutProperties(_ref, ['mt']);
	
	  return _react2.default.createElement(
	    Base,
	    _extends({
	      justify: 'center',
	      flexDirection: ['column', null, 'row'],
	      mt: mt
	    }, props),
	    _react2.default.createElement(
	      _designSystem.Box,
	      { p: [2, 3], align: ['center', null, 'right'] },
	      _react2.default.createElement(
	        _designSystem.Heading.h2,
	        { f: [5, 6], m: 0 },
	        'Start a Hack Club.'
	      ),
	      _react2.default.createElement(
	        _designSystem.Heading.h3,
	        { f: [3, 4], my: 1 },
	        'Build the class you wish you could take.'
	      ),
	      _react2.default.createElement(
	        _designSystem.Heading.h3,
	        { f: [3, 4], m: 0 },
	        'Bring the movement to your school.'
	      )
	    ),
	    _react2.default.createElement(
	      _designSystem.Box,
	      { p: 3 },
	      _react2.default.createElement(_designSystem.LargeButton.link, { to: '/start', inverted: true, children: 'Get started \xBB' })
	    ),
	    _react2.default.createElement('style', { children: 'footer{margin-top:-5rem;padding-top:8rem !important}' })
	  );
	};
	
	exports.default = Start;
	module.exports = exports['default'];

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 0 !important;\n  background-color: ', ';\n  background-image: linear-gradient(\n    -32deg,\n    ', ',\n    ', ',\n    ', '\n  );\n  clip-path: polygon(0% 0%, 100% 0, 100% 100%, 0% 90%);\n\n  h1 {\n    line-height: 1.125;\n    max-width: 48rem;\n  }\n  h2 {\n    max-width: 36rem;\n  }\n'], ['\n  padding-top: 0 !important;\n  background-color: ', ';\n  background-image: linear-gradient(\n    -32deg,\n    ', ',\n    ', ',\n    ', '\n  );\n  clip-path: polygon(0% 0%, 100% 0, 100% 100%, 0% 90%);\n\n  h1 {\n    line-height: 1.125;\n    max-width: 48rem;\n  }\n  h2 {\n    max-width: 36rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 32rem;\n  text-align: left;\n\n  ', ' {\n    &:nth-of-type(1), &:nth-of-type(3) {\n      transform: translateY(4rem);\n    }\n  }\n\n  svg {\n    width: 4rem !important;\n    height: 4rem !important;\n    flex-shrink: 0;\n    ', ' {\n      &:first-child { margin-right: 3rem; }\n      &:last-child { margin-left: 2rem; }\n    }\n    /* this is terrible */\n    @media screen and (max-width:32em) {\n      order: -1 !important;\n      margin-left: 0;\n      margin-right: 1rem;\n    }\n  }\n'], ['\n  max-width: 32rem;\n  text-align: left;\n\n  ', ' {\n    &:nth-of-type(1), &:nth-of-type(3) {\n      transform: translateY(4rem);\n    }\n  }\n\n  svg {\n    width: 4rem !important;\n    height: 4rem !important;\n    flex-shrink: 0;\n    ', ' {\n      &:first-child { margin-right: 3rem; }\n      &:last-child { margin-left: 2rem; }\n    }\n    /* this is terrible */\n    @media screen and (max-width:32em) {\n      order: -1 !important;\n      margin-left: 0;\n      margin-right: 1rem;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  position: relative;\n  ', ' {\n    &:before {\n      content: "";\n      width: 8px;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: -1.5rem;\n      background-color: ', ';\n    }\n  }\n'], ['\n  color: ', ';\n  position: relative;\n  ', ' {\n    &:before {\n      content: "";\n      width: 8px;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: -1.5rem;\n      background-color: ', ';\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5;\n'], ['\n  line-height: 1.5;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 6rem;\n  height: 6rem;\n  border-radius: 2rem;\n  flex-shrink: 0;\n'], ['\n  width: 6rem;\n  height: 6rem;\n  border-radius: 2rem;\n  flex-shrink: 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Nav = __webpack_require__(22);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Start = __webpack_require__(134);
	
	var _Start2 = _interopRequireDefault(_Start);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _designSystem.Section.withComponent('header').extend(_templateObject, function (props) {
	  return props.theme.colors.teal[6];
	}, function (props) {
	  return props.theme.colors.green[7];
	}, function (props) {
	  return props.theme.colors.teal[6];
	}, function (props) {
	  return props.theme.colors.teal[7];
	});
	
	var Module = _designSystem.Flex.extend.attrs({
	  w: [1, 1 / 2],
	  p: 4,
	  pl: [0, 4],
	  pb: [0, 4],
	  alignItems: ['flex-start', 'center']
	})(_templateObject2, function (props) {
	  return props.theme.mediaQueries[1];
	}, function (props) {
	  return props.theme.mediaQueries[1];
	});
	
	var ModuleHeading = _designSystem.Heading.h3.extend.attrs({
	  mt: 0,
	  mb: 1,
	  f: [3, 4],
	  bold: true
	})(_templateObject3, function (props) {
	  return props.theme.colors.black;
	}, function (props) {
	  return props.theme.mediaQueries[1];
	}, function (props) {
	  return (0, _designSystem.cx)(props.color);
	});
	var ModuleBody = _designSystem.Text.extend.attrs({ my: 0, f: 3, color: 'slate' })(_templateObject4);
	
	var ModuleFigure = _designSystem.Box.withComponent('figure').extend.attrs({
	  bg: 'fuschia.0',
	  mr: [4, 5],
	  ml: 3
	})(_templateObject5);
	
	_designSystem.LargeButton.link = _designSystem.LargeButton.withComponent(_gatsbyLink2.default);
	
	var title = 'Hack Club Meetings';
	var description = 'Learn about meetings at Hack Clubs, high school programming clubs at schools around the world. ' + 'Get coding club activities and programming curriculum to start a high school computer science club.';
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: title,
	      meta: [{ name: 'twitter:title', content: title }, { name: 'description', content: description }, { name: 'twitter:description', content: description }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:url', content: 'https://hackclub.com/meetings' }]
	    }),
	    _react2.default.createElement(
	      Header,
	      { color: 'white', pb: 4 },
	      _react2.default.createElement(_Nav2.default, null),
	      _react2.default.createElement(
	        _designSystem.Heading.h1,
	        { align: 'center', f: [5, 6], mx: 'auto', mt: 4, mb: 3 },
	        'At Hack Club meetings,',
	        _react2.default.createElement('br', null),
	        'everyone is making.'
	      ),
	      _react2.default.createElement(
	        _designSystem.Heading,
	        { f: [3, 4], mx: 'auto', align: 'center', bold: false, regular: true },
	        'Clubs meet weekly at high schools,',
	        _react2.default.createElement('br', null),
	        'all run by their student leaders.'
	      )
	    ),
	    _react2.default.createElement(
	      _designSystem.Flex,
	      {
	        wrap: true,
	        justify: 'space-around',
	        p: 2,
	        pb: [5, 6],
	        mx: 'auto',
	        style: { position: 'relative', maxWidth: '64rem' }
	      },
	      _react2.default.createElement(
	        Module,
	        null,
	        _react2.default.createElement(
	          _designSystem.Box,
	          null,
	          _react2.default.createElement(
	            ModuleHeading,
	            { color: 'blue.5' },
	            'Get hacking!'
	          ),
	          _react2.default.createElement(
	            ModuleBody,
	            null,
	            'Unlike a traditional coding class, everyone works on their own project at their own pace.'
	          )
	        ),
	        _react2.default.createElement(_designSystem.Icon, { name: 'memory', color: 'blue.4' })
	      ),
	      _react2.default.createElement(
	        Module,
	        null,
	        _react2.default.createElement(
	          _designSystem.Box,
	          null,
	          _react2.default.createElement(
	            ModuleHeading,
	            { color: 'yellow.5' },
	            'You can feel the energy.'
	          ),
	          _react2.default.createElement(
	            ModuleBody,
	            null,
	            'Meetings run like mini-hackathons: members are coming up with creative projects to showcase.'
	          )
	        ),
	        _react2.default.createElement(_designSystem.Icon, { name: 'flash_on', color: 'yellow.4' })
	      ),
	      _react2.default.createElement(
	        Module,
	        null,
	        _react2.default.createElement(_designSystem.Icon, { name: 'gesture', color: 'teal.5' }),
	        _react2.default.createElement(
	          _designSystem.Box,
	          null,
	          _react2.default.createElement(
	            ModuleHeading,
	            { color: 'teal.6' },
	            'No experience required.',
	            _react2.default.createElement('br', null),
	            'Maybe even encouraged.'
	          ),
	          _react2.default.createElement(
	            ModuleBody,
	            null,
	            'You\u2019re not behind if you\u2019re new to coding\u2014everyone is learning along the way.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Module,
	        null,
	        _react2.default.createElement(_designSystem.Icon, { name: 'screen_share', color: 'indigo.4' }),
	        _react2.default.createElement(
	          _designSystem.Box,
	          null,
	          _react2.default.createElement(
	            ModuleHeading,
	            { color: 'indigo.5' },
	            'Demo time!'
	          ),
	          _react2.default.createElement(
	            ModuleBody,
	            null,
	            'At the end of a meeting, everyone presents what they\u2019ve made in front of the group.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Start2.default, null),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-meetings-js-53b275135edf01418868.js